import { render, staticRenderFns } from "./chooseQuestion.vue?vue&type=template&id=be95e518&"
import script from "./chooseQuestion.vue?vue&type=script&lang=js&"
export * from "./chooseQuestion.vue?vue&type=script&lang=js&"
import style0 from "./chooseQuestion.vue?vue&type=style&index=0&id=be95e518&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports